import React, { useContext, useEffect, useMemo } from 'react';
import CashierContext from '../../../Context/CashierContext';
import functions from '../../../utils/functions';
import ActivityLoader from '../../Common/ActivityLoader';
import CompanyHeader from '../../Config/CompanyHeader';

const PopCashierDailySummary = ({ cashierId }) => {
    const { cashierSummary, setCashierId } = useContext(CashierContext);

    const summary = cashierSummary;

    const generatedAt = useMemo(() => {
        return new Date().toLocaleString('en-UG', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
        });
    }, []);

    useEffect(() => {
        if (cashierId) {
            setCashierId(cashierId);
        }
    }, [cashierId, setCashierId]);

    const formatAmount = (amount) => {
        return `UGX. ${amount || '00'}`;
    };

    const formatDate = (dateValue) => {
        if (!dateValue) return 'N/A';

        return new Date(dateValue).toLocaleDateString('en-UG', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    const transactionDateRange = useMemo(() => {
        const from = summary?.transaction_date?.from;
        const to = summary?.transaction_date?.to;

        if (!from && !to) return 'N/A';
        if (from && !to) return `From ${formatDate(from)}`;
        if (!from && to) return `Up to ${formatDate(to)}`;

        return `${formatDate(from)} - ${formatDate(to)}`;
    }, [summary]);

    const cashierName = useMemo(() => {
        if (!summary?.user) return 'N/A';

        return (
            summary.user.full_name ||
            `${summary.user.last_name || ''} ${summary.user.first_name || ''}`.trim() ||
            'N/A'
        );
    }, [summary]);

    const handlePrint = () => {
        functions.printStrip('cashier-summary');
    };

    return (
        <div className="modal" id="modal_cashier_daily_summary">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content modal-content-demo shadow">

                    <div className="modal-header">
                        <h6 className="modal-title">
                            Cashier Daily Collection Summary
                        </h6>

                        <button
                            aria-label="Close"
                            className="close"
                            data-dismiss="modal"
                            type="button"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div className="modal-body" id="cashier-summary">
                        {!summary && <ActivityLoader />}

                        {summary && (
                            <div className="docBody">

                                <div className="row">
                                    <div className="col-lg-6">
                                        <CompanyHeader />
                                    </div>

                                    <div className="col-lg-6 text-right">
                                        <p className="h3">Cashier:</p>
                                        <address>
                                            {cashierName}
                                            <br />
                                            {summary.user?.phone_number || 'N/A'}
                                        </address>
                                    </div>
                                </div>

                                <div className="row mg-t-20 mg-b-20">
                                    <div className="col-12">
                                        <p className="mb-1">
                                            <strong>Report:</strong> Cashier Daily Collection Summary
                                        </p>

                                        <p className="mb-0">
                                            <strong>Transaction Period:</strong> {transactionDateRange}
                                        </p>
                                    </div>
                                </div>

                                <div className="table-responsive mg-t-0">
                                    <table
                                        className="table table-invoice table-bordered"
                                        border="1"
                                        cellSpacing={0}
                                    >
                                        <thead>
                                            <tr>
                                                <th colSpan="2">Invoice Break-down</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {summary.invoice_breakdown?.map((item, index) => (
                                                <tr key={item.invoice_type?.invoice_type_id || index}>
                                                    <td>{item.invoice_type?.invoice_name || 'N/A'}</td>
                                                    <td>{formatAmount(item.collection?.amount_p)}</td>
                                                </tr>
                                            ))}

                                            <tr>
                                                <th colSpan="2">Totals</th>
                                            </tr>

                                            <tr>
                                                <td>Cash</td>
                                                <td>{formatAmount(summary.cash_bank?.cash?.amount_p)}</td>
                                            </tr>

                                            <tr>
                                                <td>Bank</td>
                                                <td>{formatAmount(summary.cash_bank?.bank?.amount_p)}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div className="row mt-4">
                                    <div className="col-12">
                                        <hr />

                                        <div className="d-flex justify-content-between">
                                            <small>
                                                <strong>Cashier:</strong> {cashierName}
                                            </small>

                                            <small>
                                                <strong>Generated:</strong> {generatedAt}
                                            </small>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        )}
                    </div>

                    <div className="modal-footer">
                        <button
                            type="button"
                            onClick={handlePrint}
                            className="btn ripple btn-info mb-1"
                            disabled={!summary}
                        >
                            <i className="fe fe-printer mr-1"></i>
                            Print
                        </button>

                        <button
                            className="btn ripple btn-secondary"
                            type="button"
                            data-dismiss="modal"
                        >
                            Close
                        </button>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default PopCashierDailySummary;